/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleAnalyticsAttributionShadowCandidateData } from './GoogleAnalyticsAttributionShadowCandidateData';
import {
    GoogleAnalyticsAttributionShadowCandidateDataFromJSON,
    GoogleAnalyticsAttributionShadowCandidateDataFromJSONTyped,
    GoogleAnalyticsAttributionShadowCandidateDataToJSON,
    GoogleAnalyticsAttributionShadowCandidateDataToJSONTyped,
} from './GoogleAnalyticsAttributionShadowCandidateData';

/**
 * 
 * @export
 * @interface GoogleAnalyticsAttributionShadowOrderData
 */
export interface GoogleAnalyticsAttributionShadowOrderData {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    erpIntegrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    orderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    normalizedOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    orderDate?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    turnoverWithVat?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    currencyCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    hasCurrentAttribution?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    matchingPageEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    pairedPageEvents?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    outcome?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    reasons?: Array<string>;
    /**
     * 
     * @type {Array<GoogleAnalyticsAttributionShadowCandidateData>}
     * @memberof GoogleAnalyticsAttributionShadowOrderData
     */
    candidates?: Array<GoogleAnalyticsAttributionShadowCandidateData>;
}

/**
 * Check if a given object implements the GoogleAnalyticsAttributionShadowOrderData interface.
 */
export function instanceOfGoogleAnalyticsAttributionShadowOrderData(value: object): value is GoogleAnalyticsAttributionShadowOrderData {
    return true;
}

export function GoogleAnalyticsAttributionShadowOrderDataFromJSON(json: any): GoogleAnalyticsAttributionShadowOrderData {
    return GoogleAnalyticsAttributionShadowOrderDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionShadowOrderDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsAttributionShadowOrderData {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'erpIntegrationId': json['erpIntegrationId'] == null ? undefined : json['erpIntegrationId'],
        'orderNumber': json['orderNumber'] == null ? undefined : json['orderNumber'],
        'normalizedOrderNumber': json['normalizedOrderNumber'] == null ? undefined : json['normalizedOrderNumber'],
        'orderDate': json['orderDate'] == null ? undefined : json['orderDate'],
        'turnoverWithVat': json['turnoverWithVat'] == null ? undefined : json['turnoverWithVat'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'hasCurrentAttribution': json['hasCurrentAttribution'] == null ? undefined : json['hasCurrentAttribution'],
        'matchingPageEvents': json['matchingPageEvents'] == null ? undefined : json['matchingPageEvents'],
        'pairedPageEvents': json['pairedPageEvents'] == null ? undefined : json['pairedPageEvents'],
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
        'reasons': json['reasons'] == null ? undefined : json['reasons'],
        'candidates': json['candidates'] == null ? undefined : ((json['candidates'] as Array<any>).map(GoogleAnalyticsAttributionShadowCandidateDataFromJSON)),
    };
}

export function GoogleAnalyticsAttributionShadowOrderDataToJSON(json: any): GoogleAnalyticsAttributionShadowOrderData {
    return GoogleAnalyticsAttributionShadowOrderDataToJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionShadowOrderDataToJSONTyped(value?: GoogleAnalyticsAttributionShadowOrderData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'erpIntegrationId': value['erpIntegrationId'],
        'orderNumber': value['orderNumber'],
        'normalizedOrderNumber': value['normalizedOrderNumber'],
        'orderDate': value['orderDate'],
        'turnoverWithVat': value['turnoverWithVat'],
        'currencyCode': value['currencyCode'],
        'hasCurrentAttribution': value['hasCurrentAttribution'],
        'matchingPageEvents': value['matchingPageEvents'],
        'pairedPageEvents': value['pairedPageEvents'],
        'outcome': value['outcome'],
        'reasons': value['reasons'],
        'candidates': value['candidates'] == null ? undefined : ((value['candidates'] as Array<any>).map(GoogleAnalyticsAttributionShadowCandidateDataToJSON)),
    };
}

